import axios from 'axios';

const HTTP_UNAUTHORIZED = 401;
const HTTP_ACCESS_DENIED = 403;

const BASE_API_URL = process.env.REACT_APP_API_BASE_URL!;
const LOGIN_API_URL = '/api/admin/sessions';
const SIGNUP_API_URL = '/api/signup';

const apiClient = axios.create({
  baseURL: BASE_API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'access-control-allow-origin': 'http://localhost:3000/',
    'access-control-allow-credentials': true,
  },
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Request made and server responded
      const errorResponse = error.response;
      if (
        errorResponse.status === HTTP_UNAUTHORIZED &&
        errorResponse.config.url !== LOGIN_API_URL &&
        errorResponse.config.url !== SIGNUP_API_URL
      ) {
        window.location.href = '/login?unauthorized=true';
        return null;
      }
      if (errorResponse.status === HTTP_ACCESS_DENIED) {
        window.location.href = '/unauthorized';
        return null;
      }
    } else if (error.request) {
      // Request was made but no response was received
      // console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      // console.log('Error', error.message);
    }
    return Promise.reject(error);
  }
);

export const isApiError = (error: any): boolean => axios.isAxiosError(error);
export default apiClient;
